
import { useEffect, useState, RefObject } from 'react';

// Custom hook to detect when element is in viewport
export const useInView = (options = {}) => {
  const [ref, setRef] = useState<Element | null>(null);
  const [isInView, setIsInView] = useState(false);

  useEffect(() => {
    if (!ref) return;

    const observer = new IntersectionObserver(([entry]) => {
      setIsInView(entry.isIntersecting);
    }, options);

    observer.observe(ref);

    return () => {
      observer.disconnect();
    };
  }, [ref, options]);

  return [setRef, isInView] as const;
};

// Slide up animation class for elements that enter the viewport
export const slideUpAnimation = (isInView: boolean, delay = 0) => {
  return isInView 
    ? `opacity-100 translate-y-0 transition-all duration-700 delay-[${delay}ms]` 
    : 'opacity-0 translate-y-12 transition-all duration-700';
};

// Fade in animation class
export const fadeInAnimation = (isInView: boolean, delay = 0) => {
  return isInView 
    ? `opacity-100 transition-opacity duration-700 delay-[${delay}ms]` 
    : 'opacity-0 transition-opacity duration-700';
};

// Generate staggered animation delays
export const staggeredDelay = (index: number, baseDelay = 100) => {
  return index * baseDelay;
};
